import React from 'react'
import { t } from 'i18next'
import PermanenceTableDetailList from './PermanenceTableDetailList'
import { getTenantInfoByKey } from '../../../../helpers/helpers'
import { CustomTable } from '../../../CustomTable/CustomTable'

const PermanenceTableDetail = ({ reportDetail }) => {

    const haveAccessOpenings = getTenantInfoByKey('is_access_opening')
    const haveBuildings = getTenantInfoByKey('is_building')

    const headers = [
        ...(haveAccessOpenings ? [{ key: getTenantInfoByKey('opening_name') }] : []),
        ...(haveBuildings ? [{ key: getTenantInfoByKey('building_name') }] : []),
        { key: t("ENTRY") },
        { key: t('USER_ACCESS') },
        { key: t("DEPARTURE") },
        { key: t('USER_EXIT') },
        { key: t('NORMAL_HS_SHORT') },
        { key: t('50%_HS_SHORT') },
        { key: t('100%_HS_SHORT') },
    ]

    return (
        <div>
            <CustomTable headers={headers}>
                {reportDetail.map((detail, idx) =>
                    <PermanenceTableDetailList key={idx} detail={detail} />
                )}
            </CustomTable>
        </div>
    )
}

export default PermanenceTableDetail